import {on, findAllIn, findIn, hasClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    base: '.js-dynamic-modal-toggle-add-params',
    inputs: '.js-dynamic-modal-toggle-add-params__input',
    buttons: '.js-dynamic-modal-toggle-add-params__button'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let inputs = findAllIn(selectors.inputs, baseElement);
        let buttons = findAllIn(selectors.buttons, baseElement);
        let params = "";
        let url = buttons[0].getAttribute('data-content-url');

        inputs.forEach((input, index) => {
            on('change', function () {
                url = url.replace(/[?&]anchor=[^&]*/, (match) => {
                    return match.startsWith('?') ? '?debuganchor=1' : '&debuganchor=1';
                });

                if (input.checked) {
                    params += '&' + input.getAttribute('id') + '=1';
                } else {
                    params = params.replace('&' + input.getAttribute('id') + '=1', '');
                }

                buttons.forEach((button, index) => {
                    if (params === '') {
                        button.setAttribute('disabled', 'disabled');
                    } else {
                        button.removeAttribute('disabled');
                    }

                    button.setAttribute('data-content-url', url + params);
                })
            }, input);
        })
    });
}